"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useGameBridge_1 = require("./useGameBridge");
function useQueryData(channel, id) {
    const gameBridge = (0, useGameBridge_1.default)();
    const [data, setData] = (0, react_1.useState)(null);
    const [error, setError] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        gameBridge.queryAsync(channel, id).then(setData).catch(setError);
    }, [gameBridge, channel, id]);
    return [data, error];
}
exports.default = useQueryData;
